import { QuestionPreQuestions } from "@/components/features/items/edit/_shared/ui/components/main/questions/pre-question";

import { useReservationBasePolicyPreQuestions } from "./hooks/use-pre-questions";

export const QuestionReservationBasePolicyPreQuestions = () => {
	const {
		appendQuestion,
		removeQuestion,
		reorderQuestions,
		questions,
		onSetIsRequired,
		onSetQuestionType,
		onSetTitle,
		appendOptionItem,
		removeOptionItem,
		onSetOptionItem,
	} = useReservationBasePolicyPreQuestions();

	const title = "全てのお客様への事前質問";
	const guide =
		"全てのお客様に確認したいことがある場合はここに質問を追加してください。<br />氏名、ふりがな、住所、電話番号、メールアドレス以外の情報が必要な場合にご利用ください。<br />プランごとにも独自の質問を追加することができます。<br />このページの上部で「英語」をクリックしていただくと、英語版の質問の設定が可能です。 英語版の質問を用意していない場合は、言語設定が英語の場合でも、こちらで設定した質問が表示されます。";

	return (
		<QuestionPreQuestions
			title={title}
			guide={guide}
			questions={questions}
			appendQuestion={appendQuestion}
			removeQuestion={removeQuestion}
			reorderQuestions={reorderQuestions}
			onSetIsRequired={onSetIsRequired}
			onSetQuestionType={onSetQuestionType}
			onSetTitle={onSetTitle}
			appendOptionItem={appendOptionItem}
			removeOptionItem={removeOptionItem}
			onSetOptionItem={onSetOptionItem}
		/>
	);
};

QuestionReservationBasePolicyPreQuestions.displayName = "QuestionReservationBasePolicyPreQuestions";
